export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-07.1de11d14.png";